import React from 'react';

/* eslint-disable jsx-a11y/label-has-for */

const Toggle = ({ checked, setChecked, id, disabled = false }) => (
    <div className="toggle">
      <input
        type="checkbox"
        checked={checked}
        id={id}
        onChange={(e) => {
          setChecked(e.target.checked);
        }}
        disabled={disabled}
      />

      <label htmlFor={id}>Toggle</label>
    </div>
  );

export default Toggle;




// WEBPACK FOOTER //
// ./app/Assets/js/features/components/Toggle.js